export const TermsAndConditionsVersion = 2;
